import ScrollMagic from 'scrollmagic'

export default (function() {

  function init(scrollController) {

    // "Fade in" containers
    const fadeInContainers = Array.from(document.querySelectorAll('.js-animate'))

    fadeInContainers.forEach((elem) => {
      let scene = new ScrollMagic.Scene({
        triggerElement: elem,
        triggerHook: 'onEnter',
        offset: typeof elem.dataset.animateOffset === 'undefined' && elem.offsetHeight * .6 || elem.dataset.animateOffset,
      })
      .on('enter', function() {
        let childrenElements = Array.from(elem.children)
        childrenElements.forEach((childElem) => {
          childElem.classList.add('animate')
        })
      })
      .reverse(false)
      .addTo(scrollController);
    })
  }

  return {
    init
  }

})();
